// extracted by mini-css-extract-plugin
export default {"root":"HeaderAvatar_root__QIFfC"};